<div class="banner">
    <img src="/assets/img/banner/2.jpg" alt="Banner">
</div>
<div id="cbse">
    <div class="container-fluid text-center mt-3">
        <div class="btn-group " role="group" aria-label="Message Button Group">
            <button type="button" 
            class="btn mr-1" 
            id="general-btn" 
            data-toggle="collapse" 
            data-target="#general" 
            aria-expanded="true" 
            aria-controls="General Information"
            (click)="showCard(1)">General Information</button>

            <button type="button" 
            class="btn mr-1" 
            id="document-btn" 
            data-toggle="collapse" 
            data-target="#document" 
            aria-expanded="true" 
            aria-controls="Documents and Information"
            (click)="showCard(2)">Documents and Information</button>

            <button type="button" 
            class="btn mr-1" 
            id="result-btn" 
            data-toggle="collapse" 
            data-target="#result" 
            aria-expanded="true" 
            aria-controls="Result and Academics"
            (click)="showCard(3)">Result and Academics</button>
            <button type="button" 
            class="btn mr-1" 
            id="staff-btn" 
            data-toggle="collapse" 
            data-target="#staff" 
            aria-expanded="true" 
            aria-controls="Staff (Teaching)"
            (click)="showCard(4)">Staff (Teaching)</button>

            <button type="button" 
            class="btn mr-1" 
            id="school-btn" 
            data-toggle="collapse" 
            data-target="#school" 
            aria-expanded="true" 
            aria-controls="School Infrastructure"
            (click)="showCard(5)">School Infrastructure</button>

            <!-- <button type="button" 
            class="btn mr-1" 
            id="leaving-btn" 
            data-toggle="collapse" 
            data-target="#leaving" 
            aria-expanded="true" 
            aria-controls="School Leaving Certificate"
            (click)="showCard(3)">School Leaving Certificate</button> -->

        </div>

        <!-- Message 1 -->
        <div class="row collapse show multi-collapse" id="general">
            <div class="col-12 py-5 px-md-5 detail-box">
                <div class="message-detail card inner-card shadow-lg" >
                    <h4 class="card-title text-left text-uppercase">General Information</h4>
                    <div class="card-body text-justify">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 5%;">S.No.</th>
                                    <th scope="col" style="width: 50%;">INFORMATION</th>
                                    <th scope="col" style="width: 45%;">Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <th>  NAME OF THE SCHOOL</th>
                                    <td >Maharana Pratap Public School, Kurukshetra</td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <th>AFFILIATION NO.</th>
                                    <td >530218</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <th>SCHOOL CODE</th>
                                    <td >40203</td>
                                </tr>
                                <tr>
                                    <th>4</th>
                                    <th> COMPLETE ADDRESS WITH PIN CODE</th>
                                    <td >Sector - 7, Urban Estate, Kurukshetra- 136118</td>
                                </tr>
                                <tr>
                                    <th>5</th>
                                    <th>PRINCIPAL NAME & QUALIFICATION</th>
                                    <td >Pratima Sharma (M.A., B.Ed.)</td>
                                </tr>
                                <tr>
                                    <th>6</th>
                                    <th>SCHOOL EMAIL ID</th>
                                    <td >maharanapratapschool@yahoo.co.in</td>
                                </tr>
                                <tr>
                                    <th>7</th>
                                    <th>CONTACT DETAILS (LANDLINE/MOBILE)</th>
                                    <td >8059700244</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>
            </div>
           
        </div>

        <!-- Message 2 -->
        <div class="row collapse  multi-collapse" id="document">
            <div class="col-12  py-5 px-md-5 detail-box">
                <div class="message-detail card inner-card shadow-lg">
                    <h4 class="card-title text-left text-uppercase">Documents and Information</h4>
                    <div class="card-body text-justify">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 5%;">S.No.</th>
                                    <th scope="col" style="width: 80%;">INFORMATION</th>
                                    <th scope="col" style="width: 15%;" class="text-center">Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <th>COPIES OF AFFILIATION/UPGRADATION LETTER AND RECENT EXTENSION OF AFFILIATION, IF ANY</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1OptTmtuHAJIqKKg2m8yX8tGd_vCT6XoQ/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <th> COPIES OF SOCIETIES/TRUST/COMPANY REGISTRATION/RENEWAL CERTIFICATE, AS APPLICABLE*</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1v05LEUImsqt2zbyUV1KmwKEZTkPXdGTB/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <th>COPY OF NO OBJECTION CERTIFICATE (NOC) ISSUED, IF APPLICABLE, BY THE STATE GOVT./UT*</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1WkMpXFqgyoGzz40Zt2dS2NXvHipw1jFK/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>4</th>
                                    <th>COPIES OF RECOGNITION CERTIFICATE UNDER RTE ACT, 2009, AND IT’S RENEWAL IF APPLICABLE*</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1s-Q2cQRBCJrypJDONh0_U5gGE6ncxUaj/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>5</th>
                                    <th>COPY OF VALID BUILDING SAFETY CERTIFICATE AS PER THE NATIONAL BUILDING CODE*</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1aBr5H8ZYtCi0IL1Yj0m745xNNhdv-XYO/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>6</th>
                                    <th>COPY OF VALID FIRE SAFETY CERTIFICATE ISSUED BY THE COMPETENT AUTHORITY*</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1Ha8OX4jYTqXGSPOLKBojVBZ9PiGV9zAw/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>7</th>
                                    <th>COPY OF THE DEO CERTIFICATE SUBMITTED BY THE SCHOOL FOR AFFILIATION/UPGRADATION/EXTENSION OF AFFILIATION OR SELF CERTIFICATION BY SCHOOL*</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1cqni3-5GA7IwtR9oN-rLeiHPTWZGu9Tb/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>8</th>
                                    <th>COPIES OF VALID WATER, HEALTH AND SANITATION CERTIFICATES</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1i8YoPXEBoHxNzbQuoDRTEr6s8EfseEoh/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <!-- <tr>
                                    <th>8</th>
                                    <th class="text-uppercase">Form VI for the academic year session 2022-2023</th>
                                    <td style="font-size: 20px;" class="text-center" ><a href="https://drive.google.com/file/d/1FIkRvdArnWHbSCYq5OMys9rfI2mktddA/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr> -->
                            </tbody>
                        </table>
                    </div>
                  </div>
            </div>
          
        </div>

        <!-- Message 3 -->
        <div class="row collapse multi-collapse" id="result">
            <div class="col-12  py-5 px-md-5 detail-box">
                <div class="message-detail card inner-card shadow-lg">
                    <h4 class="card-title text-left text-uppercase">Result and Academics</h4>
                    <div class="card-body text-justify">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 5%;">S.No.</th>
                                    <th scope="col" style="width: 80%;">INFORMATION</th>
                                    <th scope="col" class="text-center" style="width: 15%;">Download</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <th>FEE STRUCTURE OF THE SCHOOL</th>
                                    <td style="font-size: 20px;" class="text-center"><a href="https://drive.google.com/file/d/1XDorUSJigmut7xjJjhN9vP5HXWJdzKjh/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <th>ANNUAL ACADEMIC CALENDER*</th>
                                    <td style="font-size: 20px;" class="text-center"><a href="https://drive.google.com/file/d/1tlh2e7mDBwRvZY2k0e5p20-MXtqByXL1/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <th> LIST OF SCHOOL MANAGEMENT COMMITTEE (SMC)*</th>
                                    <td style="font-size: 20px;" class="text-center"><a href="https://drive.google.com/file/d/1uiFA46WWiiuAI2MAdjUf49JMX7UG6F9n/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>4</th>
                                    <th>LIST OF PARENTS TEACHERS ASSOCIATION (PTA) MEMBERS*</th>
                                    <td style="font-size: 20px;" class="text-center"><a href="https://drive.google.com/file/d/1C2VqAR2cj-XkHAmsVsS6-8HXesVW7cNn/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                                <tr>
                                    <th>5</th>
                                    <th class="text-uppercase"> LAST THREE-YEAR RESULT OF THE BOARD EXAMINATION AS PER APPLICABILITY</th>
                                    <td style="font-size: 20px;" class="text-center"><a href="https://drive.google.com/file/d/11x3Q4QUkq_malIPFC0VGVmjXeLRYo8XP/view?usp=sharing"  download target="_blank"><i class="fa fa-cloud-download" aria-hidden="true"></i>
                                    </a></td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 class="card-title text-left text-uppercase">RESULT CLASS: X</h4>
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 5%;">S.No.</th>
                                    <th scope="col" >YEAR</th>
                                    <th scope="col" >NO. OF REGISTERED STUDENTS</th>
                                    <th scope="col" >NO. OF STUDENTS PASSED</th>
                                    <th scope="col" >PASS PERCENTAGE</th>
                                    <th scope="col" >REMARKS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <td>2020-2021</td>
                                    <td>293</td>
                                    <td>293</td>
                                    <td>100%</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <td>2019-2020</td>
                                    <td>272</td>
                                    <td>272</td>
                                    <td>100%</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <td>2018-2019</td>
                                    <td>252</td>
                                    <td>252</td>
                                    <td>100%</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>

                        <h4 class="card-title text-left text-uppercase">RESULT CLASS: XII</h4>
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 5%;">S.No.</th>
                                    <th scope="col" >YEAR</th>
                                    <th scope="col" >NO. OF REGISTERED STUDENTS</th>
                                    <th scope="col" >NO. OF STUDENTS PASSED</th>
                                    <th scope="col" >PASS PERCENTAGE</th>
                                    <th scope="col" >REMARKS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <td>2020-2021</td>
                                    <td>251</td>
                                    <td>251</td>
                                    <td>100%</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <td>2019-2020</td>
                                    <td>192</td>
                                    <td>192</td>
                                    <td>100%</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <td>2018-2019</td>
                                    <td>178</td>
                                    <td>178</td>
                                    <td>100%</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 class="card-title text-left text-uppercase">Academic Period</h4>
                        <table class="table table-bordered table-hover">
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <td>Academic Session Period</td>
                                    <td>April to March</td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <td>Vacation Period</td>
                                    <td>As Per Government Notification</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <td>Admission Period</td>
                                    <td>27 February onwards</td>
                                </tr>
                            </tbody>
                        </table>

                        <h4 class="card-title text-left text-uppercase">Grievance</h4>
                        <table class="table table-bordered table-hover">
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <td>Name of the Grievance / Redressal Officer</td>
                                    <td>Ms. Seema Vats</td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <td>E-mail Address</td>
                                    <td>maharanapratapschool@yahoo.co.in</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <td>Contact</td>
                                    <td>8059700244</td>
                                </tr>
                                <tr>
                                    <th>4</th>
                                    <td>Members of Sexual Harassment Committee</td>
                                    <td>Ms. Pratima Sharma</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>
            </div>
           
        </div>

        <!-- Message 4 -->
        <div class="row collapse multi-collapse" id="staff">
            <div class="col-12  py-5 px-md-5 detail-box">
                <div class="message-detail card inner-card shadow-lg">
                    <h4 class="card-title text-left text-uppercase">Staff (Teaching)</h4>
                    <div class="card-body text-justify">
                        <table class="table table-bordered table-hover">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 5%;">S.No.</th>
                                    <th scope="col" style="width: 50%;">INFORMATION</th>
                                    <th scope="col" style="width: 45%;">DETAILS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <th>PRINCIPAL</th>
                                    <td >1</td>
                                </tr>
                                <tr>
                                    <th rowspan="4" class="align-middle">2</th>
                                    <th> TOTAL NO. OF TEACHERS</th>
                                    <td >149</td>
                                </tr>
                                <tr>
                                   
                                    <th>  PGT</th>
                                    <td >14</td>
                                </tr>
                                <tr>
                                   
                                    <th>   TGT</th>
                                    <td >24</td>
                                </tr>
                                <tr>
                                   
                                    <th>PRT</th>
                                    <td >110</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <th>  TEACHERS SECTION RATIO</th>
                                    <td >1:28</td>
                                </tr>
                                <tr>
                                    <th>4</th>
                                    <th> DETAILS OF SPECIAL EDUCATOR</th>
                                    <td >NA</td>
                                </tr>
                                <tr>
                                    <th>5</th>
                                    <th>  DETAILS OF COUNSELLOR AND WELNESS TEACHER</th>
                                    <td >NA</td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 class="card-title text-left text-uppercase">Salary Details</h4>
                        <table class="table table-bordered table-hover text-uppercase">
                            <thead>
                                <tr>
                                    <th scope="col" >S.No.</th>
                                    <th scope="col" >Designation PGT / TGT / PRT / Counsellor etc.</th>
                                    <th scope="col" >Scale of Pay</th>
                                    <th scope="col" >Grade Pay</th>
                                    <th scope="col" >D.A.</th>
                                    <th scope="col" >HRA</th>
                                    <th scope="col" >EPF Contribution</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <th>PGT</th>
                                    <td >Rs. 9300-34800</td>
                                    <td >Rs.4800/-</td>
                                    <td >Yes</td>
                                    <td >No</td>
                                    <td >Yes</td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <th>TGT</th>
                                    <td >Rs. 9300-34800</td>
                                    <td >Rs.4600/-</td>
                                    <td >Yes</td>
                                    <td >No</td>
                                    <td >Yes</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <th>PRT</th>
                                    <td >Rs. 9300-34800</td>
                                    <td >Rs.4200/-</td>
                                    <td >Yes</td>
                                    <td >No</td>
                                    <td >Yes</td>
                                </tr>
                            </tbody>
                        </table>
                        <h4 class="card-title text-left text-uppercase">Mode of Payment of Salary</h4>
                        <table class="table table-bordered table-hover text-uppercase">
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <td>Name of the Bank through which salary is paid</td>
                                    <td>PNB Bank</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                  </div>
            </div>
           
        </div>
        <!-- Message 5 -->
        <div class="row collapse multi-collapse" id="school">
            <div class="col-12  py-5 px-md-5 detail-box">
                <div class="message-detail card inner-card shadow-lg">
                    <h4 class="card-title text-left text-uppercase">School Infrastructure</h4>
                    <div class="card-body text-justify">
                        <table class="table table-bordered table-hover text-uppercase">
                            <thead>
                                <tr>
                                    <th scope="col" style="width: 5%;">S.No.</th>
                                    <th scope="col" style="width: 50%;">INFORMATION</th>
                                    <th scope="col" style="width: 45%;">Details</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>1</th>
                                    <th>TOTAL CAMPUS AREA OF THE SCHOOL (IN SQUARE MTR)</th>
                                    <td >21503 Square Mtrs</td>
                                </tr>
                                <tr>
                                    <th>2</th>
                                    <th>NO. AND SIZE OF THE CLASSROOMS (IN SQ FT MTR)</th>
                                    <td >Rooms - 154</td>
                                </tr>
                                <tr>
                                    <th>3</th>
                                    <th> NO. AND SIZE OF LABORATORIES INCLUDING COMPUTER LABS (IN SQ MTR)</th>
                                    <td >7 Labs <br> Physics, Chemistry, Biology, Computer – 84.07 Square Mtrs each <br> Maths – 25.64 Square Mtrs <br> Art and Craft – 84.07 Square Mtrs <br> Library – 280 Square Mtrs</td>
                                </tr>
                                <tr>
                                    <th>4</th>
                                    <th>  INTERNET FACILITY (Y/N)</th>
                                    <td >Yes</td>
                                </tr>
                                <tr>
                                    <th>5</th>
                                    <th> NO. OF GIRLS TOILETS</th>
                                    <td >48</td>
                                </tr>
                                <tr>
                                    <th>6</th>
                                    <th> NO. OF BOYS TOILETS</th>
                                    <td >47</td>
                                </tr>
                                <tr>
                                    <th>7</th>
                                    <th>LINK OF YOUTUBE VIDEO OF THE INSPECTION OF SCHOOL
                                        COVERING THE INFRASTRUCTURE OF THE SCHOOL</th>
                                    <td ></td>
                                </tr>
                               
                            </tbody>
                        </table>
                    </div>
                  </div>
            </div>
           
        </div>
        <!-- Message 6 -->
        <!-- <div class="row collapse multi-collapse" id="leaving">
            <div class="col-12  py-5 px-md-5 detail-box">
                <div class="message-detail card inner-card shadow-lg">
                    <p class="text-left">Our Pre-Kindergarten classroom is designed to help your child make significant developmental gains, communicate more successfully, and work well both independently and in group situations. Building on Preschool learning, Pre-K learning focuses on problem-solving, responsive listening and language usage, as well as social and collaborative skills, with specific lessons in Reading, Writing, Math etc.</p>
                    <p class="text-left">Each child is different, therefore special. Keeping this in focus, we endeavor to develop all the attributes & skills of the children in a holistic manner so that they adapt themselves to the constantly changing environment.
                         To inculcate creativity & critical thinking in order to encourage logical decision making & innovation, the school is all prepared to implement NEW EDUCATION POLICY.</p>
                  </div>
            </div>
           
        </div> -->
       
    </div>
</div>